<template>
  <c-ct
    :two-color-bg="type === 'secondary' ? true : false"
    :first-part-color="type === 'secondary' ? firstPartColor : null"
    :fixed-size="type === 'secondary' ? true : false"
    :bg-color="bgColor"
    :class="[cardTypeClass]"
  >
    <heading
      v-if="hasTitle"
      :has-button="type === 'secondary' ? hasButton : null"
      :has-kicker="false"
      :align="titleAlign"
      title-color="#000000"
      :is-mobile-grid="false"
      :class="[cardTypeClass] + '__heading'"
    >
      <template #title>
        <slot name="title" />
      </template>
      <slot
        v-if="type === 'secondary'"
        name="cards-wrapper-button"
      />
    </heading>

    <div
      v-if="type === 'tertiary'"
      :class="[cardTypeClass] + '__imageContainer'"
    >
      <c-image
        :class="[cardTypeClass] + '__image'"
        :image-mobile="imageMobile"
        :image-tablet="imageTablet"
        :image-desktop="imageDesktop"
        :alt="imageAlt"
      />
    </div>

    <div
      :style="
        type === 'primary' || type === 'secondary'
          ? { '--columns': columns }
          : {}
      "
      :class="[cardTypeClass] + '__cards'"
      @click="pushGTM"
    >
      <slot name="cards" />
    </div>
  </c-ct>
</template>

<script>
import CCt from '@atoms/disposition/ct.vue'
import CImage from '@atoms/image/image.vue'
import Heading from '@molecules/heading/heading.vue'
import isOutbound from '@tagging/isOutbound.js'

export default {
  name: 'cards-wrapper',
  components: { CCt, CImage, Heading },
  props: {
    type: {
      type: String,
      default: 'secondary',
      validator(value) {
        return ['primary', 'secondary', 'tertiary'].includes(value)
      },
    },
    bgColor: {
      type: String,
      default: '#EDF2F5',
    },
    firstPartColor: {
      type: String,
      default: '#EDF2F5',
    },
    hasButton: {
      type: Boolean,
      default: false,
    },
    titleAlign: {
      type: String,
      default: 'left',
    },
    columns: {
      type: Number,
      default: 2,
    },
    imageMobile: {
      type: String,
    },
    imageTablet: {
      type: String,
    },
    imageDesktop: {
      type: String,
    },
    imageAlt: {
      type: String,
    },
  },
  computed: {
    cardTypeClass() {
      return `card-wrapper--${this.type}`
    },
    hasTitle() {
      const slot = this.$slots.title
      const slotContent = slot ? slot() : []
      return slotContent.length > 0
    }
  },
  methods: {
    titleContent() {
      const slot = this.$slots.title
      if (slot) {
        const slotContent = slot()
        if (slotContent.length > 0 && slotContent[0].children) {
          return slotContent[0].children
        }
      }
      return ''
    },
    getBreadcrumbValue() {
      const breadcrumb = document.querySelectorAll('.breadcrumb__link')
      const lastBreadcrumb = breadcrumb[breadcrumb.length - 1].textContent
      return lastBreadcrumb
    },
    pushGTM(event) {
      const target = event.target.closest('.smart-card')
      const text = target?.children[1].innerText
      const button = event.target.closest('a')

      if (button) {
        window.dataLayer.push({
          event: 'click',
          section: this.titleContent() || text || this.getBreadcrumbValue() || '',
          outbound: isOutbound(button) || false,
          label: button?.innerText || ''
        })
      }
    }
  }
}
</script>

<style scoped lang="scss">
.card-wrapper {
  &--primary {
    padding: 5rem 2rem;
    position: unset;

    &__heading {
      margin: 0 auto;
      padding-bottom: 4.1rem;
      @include textAlign();

      @include screen-size("xlg") {
        padding-bottom: 4.5rem;
        max-width: 80rem;
      }
    }

    &__cards {
      display: grid;
      grid-template-columns: 1fr;
      gap: 2.5rem;

      @include screen-size("xlg") {
        grid-template-columns: repeat(var(--columns), 1fr);
        flex-direction: row;
        justify-content: flex-start;
        max-width: 80rem;
        margin: 0 auto;
      }
    }
  }

  &--secondary {
    padding: 4rem 2rem 3.5rem 2rem;

    &__heading {
      @include screen-size("xlg") {
        max-width: 81.5rem;
        margin: 0 auto;
        @include textAlign();
      }
    }

    &__cards {
      display: flex;
      flex-direction: column;
      align-items: center;
      gap: 2rem;
      padding-top: 4.1rem;

      @include screen-size("xlg") {
        display: grid;
        grid-template-columns: repeat(var(--columns), 1fr);
        align-items: stretch;
        justify-items: center;
        padding-top: 4.5rem;
        max-width: 81.5rem;
        margin: 0 auto;
        gap: 2.5rem;
      }
    }
  }

  &--tertiary {
    display: flex;
    flex-direction: column;
    gap: 3rem;
    padding: 30px 33px 62px;

    @include screen-size("xlg") {
      flex-direction: row;
      justify-content: center;
      gap: 9.5rem;
      padding: 64px 0;

    }

    &__imageContainer {
      display: flex;
      overflow: hidden;
    }

    &__image {
      width: auto;
      transition: all 0.8s;

      &:hover {
        transform: scale(1.08);
      }
    }

    &__cards {
      gap: 3rem;
      display: flex;
      flex-direction: column;

      @include screen-size("xlg") {
        gap: 3.25rem;
      }
    }
  }
}
</style>
